/** author: 胡枭 */

<template>
  <div
    class="image-content"
    :style="`width:${width || size};height:${height || size}`"
  >
    <!-- 需要包装盒子 -->
    <div
      v-if="needWrapper"
      class="box-wrapper"
      :style="`width:${width || size};height:${height || size}`"
      @click="showBigImg(imgSrc)"
    >
      <el-image class="avatar" fit="cover" :src="imgSrc" />

      <!-- 提示文字 -->
      <div v-if="tipMes" class="tip-box flex-center">
        <div class="flex-center">{{ tipMes }}</div>
      </div>
    </div>

    <!-- 不需要包装盒子 -->
    <div
      v-else
      :style="
        `${around && 'border-radius:50%;'}width:${width ||
          size};height:${height || size}`
      "
      class="wrapper"
    >
      <el-image class="avatar" fit="cover" :src="imgSrc" />
    </div>

    <!-- 弹出框，查看大图 -->
    <el-image-viewer
      v-if="dialogImage"
      :on-close="() => (dialogImage = false)"
      :url-list="[dialogImageUrl]"
    />
  </div>
</template>

<script>
import { getFileUrlByFileIdApi } from '@/api/up-file'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'PreviewImage',

  components: {
    ElImageViewer
  },

  props: {
    // 默认展示的图片
    src: {
      type: String,
      default: ''
    },

    // 通过后端的图片id获取图片地址
    fileId: {
      type: [String, Number],
      default: ''
    },

    size: {
      type: String,
      default: '8.75rem'
    },

    width: {
      type: String,
      default: ''
    },

    height: {
      type: String,
      default: ''
    },

    needPreview: {
      type: Boolean,
      default: false
    },

    needWrapper: {
      type: Boolean,
      default: false
    },

    tipMes: {
      type: String,
      default: ''
    },

    around: {
      type: Boolean,
      default: false
    },

    errorImg: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      imgSrc: '',
      dialogImage: '',
      dialogImageUrl: '',
      loadingFail: false
    }
  },

  watch: {
    fileId(val) {
      this.getFileUrlByGroupId(this.fileId)
    },

    src(val) {
      this.imgSrc = val || ''
    }
  },

  created() {
    this.imgSrc = this.src || ''

    this.getFileUrlByGroupId(this.fileId)
  },

  methods: {
    getFileUrlByGroupId(fileId) {
      if (!fileId) {
        this.imgSrc = this.errorImg
          ? this.errorImg
          : require('@/assets/images/common/fail-img.png')
        return
      }

      getFileUrlByFileIdApi({ attachmentId: fileId })
        .then(res => {
          this.imgSrc = res?.data?.external || ''
        })
        .catch(err => {
          this.loadingFail = true
          this.imgSrc = this.errorImg
            ? this.errorImg
            : require('@/assets/images/common/fail-img.png')
        })
    },

    /**
     * 对于上传的图片，展示大图
     */
    showBigImg(url) {
      if (!this.needPreview || this.loadingFail || !url) return

      this.dialogImage = true
      this.dialogImageUrl = url
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.image-content {
  display: inline-block;

  .box-wrapper {
    position: relative;
    box-sizing: border-box;
    border-radius: pixel-to-rem($n: 10);
    cursor: pointer;
    overflow: hidden;
    border: 4px solid #f5f5f5;
    font-size: pixel-to-rem($n: 16);

    .tip-box {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      height: pixel-to-rem($n: 40);
      background-color: rgba(0, 0, 0, 0.5);
      color: $white-color;
    }
  }

  .wrapper {
    box-sizing: border-box;
    border-radius: pixel-to-rem($n: 10);
    overflow: hidden;
  }

  .avatar {
    width: 100%;
    height: 100%;
  }
}
</style>
